'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.FieldsetContextProvider = exports.FieldsetContextConsumer = exports.defaultFieldsetContext = undefined;

var _react = require('react');

var defaultFieldsetContext = exports.defaultFieldsetContext = {
  disabled: false,
  size: 'default'
};

var _createContext = (0, _react.createContext)(defaultFieldsetContext),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.FieldsetContextConsumer = Consumer;
exports.FieldsetContextProvider = Provider;
exports.Consumer = Consumer; // Used downstream in FileManagerUI


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/context/FieldsetContext.js
// module id = 92
// module chunks = 3 4 5